import { render, staticRenderFns } from "./preSalesDetail.vue?vue&type=template&id=9db1d962"
import script from "./preSalesDetail.vue?vue&type=script&lang=js"
export * from "./preSalesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports